// import React from "react";
// import { connect } from "react-redux";
// import { withTranslation } from "react-i18next";
// import AppContext from "../../components/AppContext";
// import PageHeader from "../../components/PageHeader";
// import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
// import { Button, Card, Empty, Flex, Select, Spin, Tabs, Typography } from "antd";
// import RangePickerApp from "../../components/rangePickerApp";
// import dayjs from "dayjs";
// import { getBillingDateRange } from "../../helpers/getBillingDateRange";
// import Apiauth from "../../api/Apiauth";
// import { getOS, hasPermission, showToast } from "../../utils";
// import i18next from "i18next";
// import localeTH from "antd/es/date-picker/locale/th_TH";
// import localeEN from "antd/es/date-picker/locale/en_US";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import moment from "moment";
// import { DetailsModel } from "./Model";
// import { LoadingOutlined } from "@ant-design/icons";
// import { CONFIGMERCHENTID } from "../../Data/configMerchant";
// // import Swal from "sweetalert2";
// // เรียกข้างนอกเพื่อเป็นค่าเริ่มต้น
// const dataDate = getBillingDateRange();
// const { Paragraph } = Typography;
// class CreateInvoice extends React.Component {
//     static contextType = AppContext;

//     constructor(props) {
//         super(props);
//         this.state = {
//             loading: false,
//             loadingID: 0,
//             invoiceData: null,
//             titleModel: "",
//             isModalOpen: false,
//             productData: [],
//             detailsData: [],
//             merchantId: this.context?.merchantId || parseInt(localStorage.getItem("selectedID")) || null,
//             merchantName: this.context?.nameMerchang || null,
//             // ใช้ dayjs ให้เป็นมาตรฐานเดียวกัน
//             startDate: moment(dayjs(dataDate?.objectDate?.startDate)).subtract(1, "month").date(1),
//             endDate: dayjs(dataDate?.objectDate?.endDate),
//             isMobile: window.innerWidth <= 768,
//         };
//     }

//     componentDidMount() {
//         window.addEventListener("resize", this.handleResize);
//         this.fetchData(this.state.startDate);
//     }

//     componentWillUnmount() {
//         window.removeEventListener("resize", this.handleResize);
//     }

//     handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });

//     onOk = (dates) => { }

//     onChangeDate = (item) => {
//         const newStartDate = item?.startDate;
//         this.setState({ startDate: dayjs(newStartDate) }, () => this.fetchData(this.state.startDate));
//     };

//     fetchData = async (startDate) => {
//         this.setState({ loading: true });
//         const { resProfileAdmin } = this.context;
//         const mID = localStorage.getItem("selectedID");
//         const payload = {
//             startDate: dayjs(startDate).format("YYYY-MM-DD"),
//             merchantId: this.state?.merchantId || parseInt(mID),
//             preview: ["programer"].includes(resProfileAdmin?.admin_type)
//         };
//         try {
//             const res = await Apiauth.getCreateInvoice(payload);
//             if (res.status === 200) {
//                 let prodArray = Array.isArray(res.data.data.products) ? res.data.data.products : [];
//                 this.setState({ invoiceData: res.data.data, productData: prodArray }); // สมมติว่า res.data คือข้อมูลที่ต้องการเก็บใน state
//             }
//             // จัดการข้อมูลที่ได้รับที่นี่
//         } catch (error) {
//             let msg = error?.message;
//             if (error?.response?.data?.message) {
//                 msg = error?.response?.data?.message;
//             }
//             console.error("Error fetching data:", error);
//             showToast("error", msg || "Failed to fetch data.");
//         } finally {
//             // หน่วงเวลาเล็กน้อยเพื่อให้ UI ดูลื่นไหล (ตามโค้ดเดิม)
//             setTimeout(() => {
//                 this.setState({ loading: false });
//             }, 1000);
//         }
//     };

//     getAntdLocale = () => {
//         const currentLanguage = i18next.language;
//         return currentLanguage === "th" || currentLanguage === "lao" ? localeTH : localeEN;
//     };

//     // ปรับปรุงฟังก์ชัน handleDownloadPdf
//     handleDownloadPdf = async () => {
//         let devices = getOS()?.os;
//         let msg = "";

//         if (devices === "macOS" || devices === "iOS") {
//             msg =
//                 "ระบบปฏิบัติการ iOS จะไม่ยอมให้เว็บไซต์ดาวน์โหลดไฟล์โดยตรงเหมือนบน PC  ทำให้ผู้ใช้อาจต้องกด 'Save to Files' ด้วยตนเองหลังจากที่ไฟล์ PDF ถูกสร้างขึ้นแล้ว";
//         } else {
//             msg = "สร้างไฟล์ PDF สำเร็จ";
//         }
//         const printContent = document.getElementById("printContent");
//         const { nameMerchang } = this.context;
//         this.setState({ loading: true });

//         if (!printContent) {
//             this.setState({ loading: false });
//             showToast("error", "ไม่พบข้อมูลที่ต้องการพิมพ์");
//             return;
//         }

//         try {
//             const canvas = await html2canvas(printContent, {
//                 scale: 2,
//                 useCORS: true, // สำคัญ: อนุญาตให้ดึงภาพข้ามโดเมนได้
//             });
//             const imgData = canvas.toDataURL("image/png");
//             const pdf = new jsPDF("p", "mm", "a4");
//             const imgProps = pdf.getImageProperties(imgData);

//             const margin = 10;
//             const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
//             const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

//             pdf.addImage(imgData, "PNG", margin, margin, pdfWidth, pdfHeight);
//             pdf.save(`invoice(${this.state.invoiceData?.status})_${nameMerchang}_Ref_${this.state.invoiceData?.invoiceNumber}.pdf`);

//             this.setState({ loading: false });

//             if (devices === "macOS" || devices === "iOS") {
//                 console.warn(msg);

//             } else {
//             }
//         } catch (error) {
//             console.error("เกิดข้อผิดพลาดในการสร้าง PDF:", error);
//             this.setState({ loading: false });
//             showToast("error", `ไม่สามารถดาวน์โหลดใบแจ้งหนี้ได้: ${error.message}`);
//         }
//     };

//     onOpen = (id, title, details) => title && details && (this.setState({ detailsData: details, isModalOpen: true, titleModel: title, loadingID: id }));
//     onClose = () => this.setState({ detailsData: [], isModalOpen: false, titleModel: "", loadingID: 0 });

//     render() {
//         // ดึง t และ props อื่นๆ
//         const { t } = this.props;
//         const { nameMerchang, resProfileAdmin, resAllDataMerchang } = this.context;
//         const { loading, startDate, invoiceData, productData, isMobile, detailsData, titleModel, loadingID, merchantId } = this.state;
//         const currentLanguage = i18next.language;

//         let currentLng = currentLanguage === "lao" ? "lo" : currentLanguage;

//         let statusInvoices = invoiceData?.status;
//         let isPaid = statusInvoices === "PAID";
//         // คำนวณหาผลรวมของรายการทั้งหมด
//         const totalTransactions = productData?.reduce((sum, item) => sum + (item.totalTransactions || 0), 0);
//         const totalFee = productData?.reduce((sum, item) => sum + (item.fee || 0), 0);

//         dayjs.locale(currentLng);

//         const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];

//         // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน view_past
//         const accessible_download = hasPermission(userPermissions, "download_Invoices");
//         const accessible_view_past = hasPermission(userPermissions, "view_past_Invoices");
//         let arrData = Array.isArray(resAllDataMerchang) ? resAllDataMerchang : [];
//         const items = [{
//             label: null,
//             key: "1",
//             children: (
//                 <>
//                     {!invoiceData || loading ? <div className="p-3"><Empty description={t("No data")} /></div> :
//                         <div className="card-body pt-1">
//                             <div id="printContent" className="tab-pane">
//                                 {!invoiceData || loading ? null : <p className="mb-3" style={{ fontSize: 15, fontWeight: "500", }}><>{t("This invoice is for the billing period", { startDate: dayjs(invoiceData?.endDate).date(1).format("MMM DD"), endDate: dayjs(invoiceData?.endDate).format("MMM DD, YYYY") })}</></p>}
//                                 <div className="row clearfix">
//                                     <span style={{ color: "rgb(90 90 90)" }}></span>

//                                     <div className="col-md-6 col-sm-6">
//                                         <address>
//                                             <strong>{t("Monthly")}:</strong>{" "}
//                                             <span style={{ color: "rgb(90 90 90)" }}>{dayjs(startDate).format("MMM YYYY")}</span>
//                                             <br />

//                                             <strong>{t("Merchant")}:</strong>{" "}
//                                             <span style={{ color: "rgb(90 90 90)" }}>{this.state?.merchantName || nameMerchang || "-"}</span>
//                                             <br />
//                                             <strong>{t("Status")}: </strong>{" "}
//                                             <span
//                                                 className={`badge badge-${statusInvoices === "PAID" ? "success" :
//                                                     statusInvoices === "UNPAID" ? "danger" : "warning"
//                                                     } m-b-0`}
//                                             >
//                                                 {t(statusInvoices || "UNKNOWN")}
//                                             </span>
//                                         </address>
//                                     </div>
//                                     <div className="col-md-6 col-sm-6">
//                                         <address className="text-right">
//                                             <strong>{t("Ref")}:</strong>{" "}
//                                             <span style={{ color: "rgb(90 90 90)" }}>{invoiceData?.invoiceNumber || "-"}</span>
//                                             <br />
//                                             <strong>{isPaid ? t("paidDate") : t("dueDate")}:</strong>{" "}
//                                             <span style={{ color: "rgb(90 90 90)" }}>{moment(isPaid ? invoiceData?.paidDate : invoiceData?.dueDate).locale(currentLng).format("ll")}</span>
//                                             <br />
//                                             <strong>{t("paidMethod")}:</strong>{" "}
//                                             <span style={{ color: "rgb(90 90 90)" }}>{invoiceData?.paidMethod || "-"}</span>

//                                         </address>
//                                     </div>
//                                 </div>

//                                 <div className="row clearfix">
//                                     <div className="col-md-12">
//                                         <div className="body table-responsive">
//                                             <table className="table table-hover">
//                                                 <thead className="thead-dark">
//                                                     <tr className="text-truncate">
//                                                         <th>#</th>
//                                                         <th>{t("Type")}</th>
//                                                         <th className="text-center">{t("Transactions all")}</th>
//                                                         <th className="text-right">{t("fee")}</th>
//                                                         <th className="text-right">{t("Details")}</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {productData && productData.length > 0 ? (
//                                                         <>
//                                                             {productData.map((item, id) => (
//                                                                 <tr key={id}>
//                                                                     <td>{id + 1}</td>
//                                                                     <td>{t(item?.name)}</td>
//                                                                     <td className="text-center">{item?.totalTransactions}</td>
//                                                                     <td className="text-right">
//                                                                         {item?.fee.toLocaleString(undefined, { minimumFractionDigits: 2 })}
//                                                                     </td>
//                                                                     <td className="text-right" >
//                                                                         {item?.details?.length > 0 ? <u onClick={() => this.onOpen(id + 1, item.name, item.details)} style={{ cursor: "pointer", color: "skyblue" }} className="hover">{loadingID === id + 1 ? <LoadingOutlined /> : "View"}</u> : null}
//                                                                     </td>
//                                                                 </tr>
//                                                             ))}
//                                                             <tr className="font-weight-bold" style={{ background: "#f8f9fa" }}>
//                                                                 <td colSpan="2" className="text-right">{t("Total")}:</td>
//                                                                 <td className="text-center">{totalTransactions} {t("items")}</td>
//                                                                 <td className="text-right">
//                                                                 {totalFee.toLocaleString(undefined, { minimumFractionDigits: 2 })} .-

//                                                                 </td>
//                                                                 <td className="text-center">
//                                                                  {["programer"].includes(resProfileAdmin?.admin_type) && <Paragraph style={{ marginRight: 8 }}
//                                                                         copyable={{
//                                                                             text: async () =>
//                                                                                 new Promise(resolve => {
//                                                                                     setTimeout(() => {
//                                                                                         resolve(`${this.state?.merchantName || nameMerchang} => ${dayjs(startDate).format("MMM YYYY")} = THB ${totalFee.toLocaleString(undefined, { minimumFractionDigits: 2 })} .-`);
//                                                                                     }, 500);
//                                                                                 }),
//                                                                         }}
//                                                                     >
//                                                                         Copy
//                                                                     </Paragraph>}
//                                                                 </td>

//                                                             </tr>
//                                                         </>
//                                                     ) : (
//                                                         !loading && <tr><td colSpan="4"><Empty description={t("No data")} /></td></tr>
//                                                     )}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <hr />
//                                 <div className="row clearfix">
//                                     <div className="col-md-6">
//                                         <h6>{t("note")}:</h6>
//                                         <p>
//                                             {invoiceData?.note || "-"} {invoiceData?.updatedBy || ""} <br />
//                                         </p>
//                                     </div>
//                                     <div className="col-md-6 text-right">
//                                         <span style={{ fontWeight: "500", fontSize: "0.9rem" }}>{t("Total Due")}</span>
//                                         <h6 className={`text-${statusInvoices === "PAID" ? "success" :
//                                             statusInvoices === "UNPAID" ? "danger" : "warning"
//                                             } m-b-0 font-weight-bold`}>
//                                             {Number(invoiceData?.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })} .-


//                                         </h6>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>}
//                 </>
//             ),
//         }];
//         const handleChange = (value) => {
//             let arrData = Array.isArray(resAllDataMerchang) ? resAllDataMerchang : [];

//             let merchantName = arrData.find(item => item.id === value)?.name || null;
//             this.setState({ merchantId: value, merchantName: merchantName }, () => this.fetchData(this.state.startDate));
//         };
//         const operationsSlot = {
//             left: <Button className={`tabs-extra-demo-button mb-2 ${!accessible_download ? "d-none" : ""}`} type="primary" disabled={!invoiceData || loading} icon={<i className="fa fa-file-pdf-o"></i>} onClick={() => accessible_download ? this.handleDownloadPdf() : alert(t("You are not permitted to download data."))} >Download PDF</Button>,
//             right: accessible_view_past ? <RangePickerApp
//                 onChangeDate={this.onChangeDate}
//                 isMobile={isMobile}
//                 startDate={startDate}
//                 onOk={this.onOk}
//                 t={t}
//                 resProfileAdmin={resProfileAdmin}
//             /> : null,
//         };

//         return (
//             <>
//                 <DetailsModel isModalOpen={this.state.isModalOpen} handleCancel={this.onClose} t={t} detailsData={detailsData} titleModel={titleModel} />
//                 <div
//                     style={{ flex: 1 }}
//                     onClick={() => document.body.classList.remove("offcanvas-active")}
//                 >
//                     <div className="container-fluid">
//                         <PageHeader
//                             HeaderText={t("invoices")}
//                             Breadcrumb={[
//                                 {
//                                     name: removeSlashesFromPath(window.location.pathname),
//                                     navigate: window.location.pathname,
//                                 },
//                             ]}
//                         />

//                         <div className="row clearfix">
//                             <div className="col-lg-12">
//                                 <Spin spinning={loading} tip={t("Loading...")}>
//                                     <div className="">
//                                         <div className="body">
//                                             <Card
//                                                 styles={{ header: { borderBottom: "none", minHeight: 0 } }}
//                                                 size="small"
//                                             >
//                                                 {/* invoices info*/}

//                                                 {["programer"].includes(resProfileAdmin?.admin_type) &&
//                                                     (<Flex style={{ marginTop: 16, justifyContent: "flex-end", }} wrap="wrap">
//                                                         <label className="d-block" style={{ marginRight: 8, fontWeight: "500", fontSize: 14 }}>{t("Select ")}:</label>
//                                                         <Select
//                                                             defaultValue={merchantId}
//                                                             style={{ width: 161, marginRight: 20 }}
//                                                             onChange={handleChange}
//                                                             allowClear
//                                                             options={
//                                                                 arrData.filter((item) => !CONFIGMERCHENTID.includes(item.id)) // กรองออก merchantId ที่อยู่ใน CONFIGMERCHENTID
//                                                                     .map((item, index) => ({
//                                                                         value: item.id,
//                                                                         filter: item.name,
//                                                                         label: (
//                                                                             <span>
//                                                                                 {index + 1}. {item.name} ({item.id})
//                                                                             </span>
//                                                                         ),
//                                                                     }))
//                                                             }
//                                                         />
//                                                     </Flex>)
//                                                 }
//                                                 <Tabs
//                                                     id="invoices-tabs"
//                                                     defaultActiveKey="1"
//                                                     items={items}
//                                                     size="small"
//                                                     tabBarExtraContent={operationsSlot}
//                                                     style={{ padding: "10px 10px" }}
//                                                     onChange={(key) => console.log(key)}
//                                                 />
//                                             </Card>
//                                         </div>
//                                     </div>
//                                 </Spin>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </>
//         );
//     }
// }

// const mapStateToProps = ({ ioTReducer }) => ({
//     isSecuritySystem: ioTReducer.isSecuritySystem,
// });

// export default connect(mapStateToProps, {})(withTranslation()(CreateInvoice));

import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AppContext from "../../components/AppContext";
import PageHeader from "../../components/PageHeader";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { Button, Card, Empty, Flex, Select, Spin, Switch, Tabs, Typography } from "antd";
import RangePickerApp from "../../components/rangePickerApp";
import dayjs from "dayjs";
import "dayjs/locale/th";
import "dayjs/locale/lo";
import { getBillingDateRange } from "../../helpers/getBillingDateRange";
import Apiauth from "../../api/Apiauth";
import { hasPermission, showToast } from "../../utils";
import i18next from "i18next";
import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { DetailsModel } from "./Model";
import { CheckOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { CONFIGMERCHENTID } from "../../Data/configMerchant";

const dataDate = getBillingDateRange();
const { Paragraph } = Typography;

class CreateInvoice extends React.Component {
    static contextType = AppContext;
    timerId = null; // Reference สำหรับ Clear Timeout

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingID: 0,
            invoiceData: null,
            titleModel: "",
            isModalOpen: false,
            showAllMerchant: false,
            productData: [],
            detailsData: [],
            merchantId: null,
            merchantName: null,
            startDate: dayjs(dataDate?.objectDate?.startDate).subtract(1, "month").date(1),
            endDate: dayjs(dataDate?.objectDate?.endDate),
            isMobile: window.innerWidth <= 768,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);

        // กำหนดค่า Initial Merchant ID จาก Context หรือ LocalStorage
        const initialMerchantId = this.context?.merchantId || parseInt(localStorage.getItem("selectedID")) || null;
        const initialMerchantName = this.context?.nameMerchang || null;

        this.setState({
            merchantId: initialMerchantId,
            merchantName: initialMerchantName
        }, () => {
            this.fetchData(this.state.startDate);
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        if (this.timerId) clearTimeout(this.timerId); // ล้าง Timeout ป้องกัน Memory Leak
    }

    handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });

    onOk = (dates) => { };

    onChangeDate = (item) => {
        const newStartDate = item?.startDate;
        this.setState({ startDate: dayjs(newStartDate) }, () => this.fetchData(this.state.startDate));
    };

    fetchData = async (startDate) => {
        this.setState({ loading: true });
        const { resProfileAdmin } = this.context;
        const mID = localStorage.getItem("selectedID");
        const payload = {
            startDate: dayjs(startDate).format("YYYY-MM-DD"),
            merchantId: this.state?.merchantId || parseInt(mID),
            preview: ["programer"].includes(resProfileAdmin?.admin_type)
        };
        try {
            const res = await Apiauth.getCreateInvoice(payload);
            if (res.status === 200) {
                let prodArray = Array.isArray(res.data?.data?.products) ? res.data.data.products : [];
                this.setState({ invoiceData: res.data?.data, productData: prodArray });
            }
        } catch (error) {
            let msg = error?.response?.data?.message || error?.message || "Failed to fetch data.";
            console.error("Error fetching data:", error);
            showToast("error", msg);
        } finally {
            this.timerId = setTimeout(() => {
                this.setState({ loading: false });
            }, 1000);
        }
    };

    getAntdLocale = () => {
        const currentLanguage = i18next.language;
        return currentLanguage === "th" || currentLanguage === "lao" ? localeTH : localeEN;
    };

    handleDownloadPdf = async () => {
        // let devices = getOS()?.os;
        const printContent = document.getElementById("printContent");
        const { nameMerchang } = this.context;
        this.setState({ loading: true });

        if (!printContent) {
            this.setState({ loading: false });
            showToast("error", "ไม่พบข้อมูลที่ต้องการพิมพ์");
            return;
        }

        try {
            const canvas = await html2canvas(printContent, {
                scale: 2,
                useCORS: true,
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgProps = pdf.getImageProperties(imgData);

            const margin = 10;
            const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, "PNG", margin, margin, pdfWidth, pdfHeight);
            pdf.save(`invoice(${this.state.invoiceData?.status})_${nameMerchang}_Ref_${this.state.invoiceData?.invoiceNumber}.pdf`);

            this.setState({ loading: false });
        } catch (error) {
            console.error("เกิดข้อผิดพลาดในการสร้าง PDF:", error);
            this.setState({ loading: false });
            showToast("error", `ไม่สามารถดาวน์โหลดใบแจ้งหนี้ได้: ${error.message}`);
        }
    };

    onOpen = (id, title, details) => title && details && (this.setState({ detailsData: details, isModalOpen: true, titleModel: title, loadingID: id }));
    onClose = () => this.setState({ detailsData: [], isModalOpen: false, titleModel: "", loadingID: 0 });

    handleChange = (value) => {
        const { resAllDataMerchang } = this.context;
        let arrData = Array.isArray(resAllDataMerchang) ? resAllDataMerchang : [];
        let merchantName = arrData.find(item => item.id === value)?.name || null;

        this.setState({ merchantId: value, merchantName: merchantName }, () => this.fetchData(this.state.startDate));
    };

    render() {
        const { t } = this.props;
        const { nameMerchang, resProfileAdmin, resAllDataMerchang } = this.context;
        const { loading, startDate, invoiceData, productData, isMobile, detailsData, titleModel, loadingID, merchantId, showAllMerchant } = this.state;

        const currentLanguage = i18next.language;
        let currentLng = currentLanguage === "lao" ? "lo" : currentLanguage;

        let statusInvoices = invoiceData?.status;
        let isPaid = statusInvoices === "PAID";

        const totalTransactions = productData?.reduce((sum, item) => sum + (item.totalTransactions || 0), 0);
        const totalFee = productData?.reduce((sum, item) => sum + (item.fee || 0), 0);

        dayjs.locale(currentLng);

        const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];
        const accessible_download = hasPermission(userPermissions, "download_Invoices");
        const accessible_view_past = hasPermission(userPermissions, "view_past_Invoices");

        let arrData = Array.isArray(resAllDataMerchang) ? resAllDataMerchang : [];

        // กรองรายการ Merchant ตาม Switch
        const filteredMerchants = arrData.filter((item) => showAllMerchant ? true : !CONFIGMERCHENTID.includes(item.id));

        const items = [{
            label: null,
            key: "1",
            children: (
                <>
                    {!invoiceData || loading ? <div className="p-3"><Empty description={t("No data")} /></div> :
                        <div className="card-body pt-1">
                            <div id="printContent" className="tab-pane">
                                {!invoiceData || loading ? null : <p className="mb-3" style={{ fontSize: 15, fontWeight: "500", }}>{t("This invoice is for the billing period", { startDate: dayjs(invoiceData?.endDate).date(1).format("MMM DD"), endDate: dayjs(invoiceData?.endDate).format("MMM DD, YYYY") })}</p>}
                                <div className="row clearfix">
                                    <div className="col-md-6 col-sm-6">
                                        <address>
                                            <strong>{t("Monthly")}:</strong>{" "}
                                            <span style={{ color: "rgb(90 90 90)" }}>{dayjs(startDate).format("MMM YYYY")}</span>
                                            <br />

                                            <strong>{t("Merchant")}:</strong>{" "}
                                            <span style={{ color: "rgb(90 90 90)" }}>{this.state?.merchantName || nameMerchang || "-"}</span>
                                            <br />
                                            <strong>{t("Status")}: </strong>{" "}
                                            <span
                                                className={`badge badge-${statusInvoices === "PAID" ? "success" :
                                                    statusInvoices === "UNPAID" ? "danger" : "warning"
                                                    } m-b-0`}
                                            >
                                                {t(statusInvoices || "UNKNOWN")}
                                            </span>
                                        </address>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <address className="text-right">
                                            <strong>{t("Ref")}:</strong>{" "}
                                            <span style={{ color: "rgb(90 90 90)" }}>{invoiceData?.invoiceNumber || "-"}</span>
                                            <br />
                                            <strong>{isPaid ? t("paidDate") : t("dueDate")}:</strong>{" "}
                                            <span style={{ color: "rgb(90 90 90)" }}>{dayjs(isPaid ? invoiceData?.paidDate : invoiceData?.dueDate).locale(currentLng).format("DD MMM YYYY")}</span>
                                            <br />
                                            <strong>{t("paidMethod")}:</strong>{" "}
                                            <span style={{ color: "rgb(90 90 90)" }}>{invoiceData?.paidMethod || "-"}</span>
                                        </address>
                                    </div>
                                </div>

                                <div className="row clearfix">
                                    <div className="col-md-12">
                                        <div className="body table-responsive">
                                            <table className="table table-hover">
                                                <thead className="thead-dark">
                                                    <tr className="text-truncate">
                                                        <th>#</th>
                                                        <th>{t("Type")}</th>
                                                        <th className="text-center">{t("Transactions all")}</th>
                                                        <th className="text-right">{t("fee")}</th>
                                                        <th className="text-right">{t("Details")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {productData && productData.length > 0 ? (
                                                        <>
                                                            {productData.map((item, id) => (
                                                                <tr key={id}>
                                                                    <td>{id + 1}</td>
                                                                    <td>{t(item?.name)}</td>
                                                                    <td className="text-center">{item?.totalTransactions}</td>
                                                                    <td className="text-right">
                                                                        {item?.fee?.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                    </td>
                                                                    <td className="text-right">
                                                                        {item?.details?.length > 0 ? <u onClick={() => this.onOpen(id + 1, item.name, item.details)} style={{ cursor: "pointer", color: "skyblue" }} className="hover">{loadingID === id + 1 ? <LoadingOutlined /> : "View"}</u> : null}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                            <tr className="font-weight-bold" style={{ background: "#f8f9fa" }}>
                                                                <td colSpan="2" className="text-right">{t("Total")}:</td>
                                                                <td className="text-center">{totalTransactions} {t("items")}</td>
                                                                <td className="text-right">
                                                                    {totalFee.toLocaleString(undefined, { minimumFractionDigits: 2 })} .-
                                                                </td>
                                                                <td className="text-center">
                                                                    {["programer"].includes(resProfileAdmin?.admin_type) && <Paragraph style={{ marginRight: 8 }}
                                                                        copyable={{
                                                                            text: async () =>
                                                                                new Promise(resolve => {
                                                                                    setTimeout(() => {
                                                                                        resolve(`${this.state?.merchantName || nameMerchang} => ${dayjs(startDate).format("MMM YYYY")} = THB ${totalFee.toLocaleString(undefined, { minimumFractionDigits: 2 })} .-`);
                                                                                    }, 500);
                                                                                }),
                                                                        }}
                                                                    >
                                                                        Copy
                                                                    </Paragraph>}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ) : (
                                                        !loading && <tr><td colSpan="5"><Empty description={t("No data")} /></td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <hr />
                                <div className="row clearfix">
                                    <div className="col-md-6">
                                        <h6>{t("note")}:</h6>
                                        <p>
                                            {invoiceData?.note || "-"} {invoiceData?.updatedBy || ""} <br />
                                        </p>
                                    </div>
                                    <div className="col-md-6 text-right">
                                        <span style={{ fontWeight: "500", fontSize: "0.9rem" }}>{t("Total Due")}</span>
                                        <h6 className={`text-${statusInvoices === "PAID" ? "success" :
                                            statusInvoices === "UNPAID" ? "danger" : "warning"
                                            } m-b-0 font-weight-bold`}>
                                            {Number(invoiceData?.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })} .-
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>}
                </>
            ),
        }];

        const operationsSlot = {
            left: <Button className={`tabs-extra-demo-button mb-2 ${!accessible_download ? "d-none" : ""}`} type="primary" disabled={!invoiceData || loading} icon={<i className="fa fa-file-pdf-o"></i>} onClick={() => accessible_download ? this.handleDownloadPdf() : alert(t("You are not permitted to download data."))} >Download PDF</Button>,
            right: accessible_view_past ? <RangePickerApp
                onChangeDate={this.onChangeDate}
                isMobile={isMobile}
                startDate={startDate}
                onOk={this.onOk}
                t={t}
                resProfileAdmin={resProfileAdmin}
            /> : null,
        };

        return (
            <>
                <DetailsModel isModalOpen={this.state.isModalOpen} handleCancel={this.onClose} t={t} detailsData={detailsData} titleModel={titleModel} />
                <div
                    style={{ flex: 1 }}
                    onClick={() => document.body.classList.remove("offcanvas-active")}
                >
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText={t("invoices")}
                            Breadcrumb={[
                                {
                                    name: removeSlashesFromPath(window.location.pathname),
                                    navigate: window.location.pathname,
                                },
                            ]}
                        />

                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <Spin spinning={loading} tip={t("Loading...")}>
                                    <div className="body">
                                        <Card
                                            styles={{ header: { borderBottom: "none", minHeight: 0 } }}
                                            size="small"
                                        >
                                            {["programer"].includes(resProfileAdmin?.admin_type) && (
                                                <Flex
                                                    justify="space-between"
                                                    align="center"
                                                    wrap="wrap"
                                                    gap="middle"
                                                    style={{ marginTop: 16, marginBottom: 16, marginLeft: 5 }}
                                                >
                                                    {/* สวิตช์แสดงร้านค้าทั้งหมด (ฝั่งซ้าย) */}
                                                    <Flex align="center" gap="small">
                                                        <label style={{ fontWeight: "500", fontSize: 14, marginBottom: 0 }}>
                                                            {t("แสดงร้านค้าทั้งหมด")}:
                                                        </label>
                                                        <Switch
                                                            onChange={(checked) => this.setState({ showAllMerchant: checked })}
                                                            checked={showAllMerchant}
                                                            checkedChildren={<CheckOutlined />}
                                                            unCheckedChildren={<CloseOutlined />}
                                                        />
                                                    </Flex>

                                                    {/* ตัวเลือก Merchant (ฝั่งขวา) */}
                                                    <Flex style={{alignItems: "center"}} align="center" gap="small">
                                                        <label style={{ fontWeight: "500", fontSize: 14, marginBottom: 0 }}>
                                                            {t("Select ")}:
                                                        </label>
                                                        <Select
                                                            value={merchantId}
                                                            style={{ width: 240 }}
                                                            onChange={this.handleChange}
                                                            allowClear
                                                            options={filteredMerchants.map((item, index) => ({
                                                                value: item.id,
                                                                label: `${index + 1}. ${item.name} (${item.id})`,
                                                            }))}
                                                        />
                                                    </Flex>
                                                </Flex>
                                            )}

                                            <Tabs
                                                id="invoices-tabs"
                                                defaultActiveKey="1"
                                                items={items}
                                                size="small"
                                                tabBarExtraContent={operationsSlot}
                                                style={{ padding: "10px 10px" }}
                                            />
                                        </Card>
                                    </div>
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default connect(mapStateToProps, {})(withTranslation()(CreateInvoice));